export default __webpack_public_path__ + "twitter-sqr-v1.svg";